// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { HTMLColors } from '@Constants/colors';
import { IconBoolean } from '@Atoms/Info/IconBoolean/IconBoolean';
import { useLocalMessage } from '@Helpers/locale';
import { ICONS } from '@Constants/iconsApp';

import './IsMandatory.scss';

interface IsMandatoryProps {
    value: boolean;
    onClick?: () => void;
    readOnly?: boolean;
}

export const IsMandatory = ({ value, onClick, readOnly = false }: IsMandatoryProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <IconBoolean
            icon={<ICONS.StarExclamation />}
            className={'icon-mandatory'}
            value={value}
            onClick={onClick}
            readOnly={readOnly}
            onTrue={{ color: HTMLColors.RED, icon: <ICONS.StarExclamation /> }}
            label={i('task.mandatory.tooltip')}
        />
    );
};
